import {safeWebUrlOf} from '@Utils/url.util';
import {GA4EventName} from '@Libraries/ga-events';
import {openDesignInNewTab} from '@Libraries/open-design-in-new-tab.library';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityCardAction} from './entity-card-action.types';

const TEMPLATE_POPUP_BLOCKED_GROWL_KEY = 'ai-chat-template-popup-blocked';

interface TemplateEntityPayload {
  viewUrl: string;
}

/** Clicking a template opens its page on PosterMyWall in a new tab; a view link that is not a web link opens nothing. */
export const templateEntityCardAction: EntityCardAction<TemplateEntityPayload> = {
  entityType: EntityCardEntityType.TEMPLATE,
  parsePayload: (raw): TemplateEntityPayload => ({viewUrl: safeWebUrlOf(raw.viewUrl)}),
  onClick: (payload): void => {
    if (!payload.viewUrl) {
      return;
    }

    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_TEMPLATE_TILE_OPENED);
    openDesignInNewTab(payload.viewUrl, {key: TEMPLATE_POPUP_BLOCKED_GROWL_KEY, text: window.i18next.t('pmwjs_ai_chat_popup_blocked_open_template'), actionLabel: window.i18next.t('pmwjs_open')});
  },
};
